import { useSelect } from "@refinedev/antd";
import {
  Form,
  FormProps,
  InputNumber,
  Modal,
  ModalProps,
  Select,
  Space,
} from "antd";

type Props = {
  modalProps: ModalProps;
  formProps: FormProps;
};

export const ModalAudioTaskPublish: React.FC<Props> = ({
  modalProps,
  formProps,
}) => {
  const { selectProps: audioBookSelectProps } = useSelect({
    resource: "book",
    queryOptions: {
      enabled: true,
    },
    optionValue: "_id",
    optionLabel: "name",
    filters: [
      {
        field: "type",
        operator: "eq",
        value: "audio",
      },
    ],
    onSearch: (value) => {
      return [
        {
          field: "q",
          operator: "eq",
          value,
        },
      ];
    },
  });

  return (
    <Modal {...modalProps} centered width="480px" title="Xuất bản">
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Truyện audio"
          name="bookId"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập không để trống",
            },
          ]}
        >
          <Select {...audioBookSelectProps} />
        </Form.Item>
        {/*<Form.Item*/}
        {/*  label="Truyện chữ"*/}
        {/*  name="refBookId"*/}
        {/*  rules={[*/}
        {/*    {*/}
        {/*      required: true,*/}
        {/*      message: "Vui lòng nhập không để trống",*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*  hidden={true}*/}
        {/*>*/}
        {/*  <Input />*/}
        {/*</Form.Item>*/}
        <Space
          style={{
            display: "flex",
          }}
        >
          <Form.Item
            label="Từ số"
            name="from"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập không để trống",
              },
            ]}
          >
            <InputNumber
              min={0}
              style={{
                width: "100%",
              }}
            />
          </Form.Item>
          <Form.Item
            label="Đến số"
            name="to"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập không để trống",
              },
            ]}
          >
            <InputNumber
              min={0}
              style={{
                width: "100%",
              }}
            />
          </Form.Item>
        </Space>
        <Form.Item
          label="Offset"
          name="offset"
          initialValue={0}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập không để trống",
            },
          ]}
        >
          <InputNumber min={0} defaultValue={0} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
